import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const logout = async () => {
    try {
        const response = await axios.delete(routes.logout, AXIOS_DEFAULT_CONFIG);
        return response;
    } finally {
        localStorage.removeItem("authToken");
    }
};
export default logout;